export let messageGroupLabel = "a6Pdo";
export let meetingRequestGroupLabel = "$_ayAe";
export let meetingCancelationGroupLabel = "$axjib";
export let meetingDeclineGroupLabel = "eIHzz";
export let meetingAcceptanceGroupLabel = "tEz$fe";
export let meetingTentativeAcceptanceGroupLabel = "v$cZLd";
export let automaticReplyGroupLabel = "MvBgfe";
export let undeliveredReportGroupLabel = "wDjMhc";
export let otherGroupLabel = "pb_lHb";
export default {messageGroupLabel,meetingRequestGroupLabel,meetingCancelationGroupLabel,meetingDeclineGroupLabel,meetingAcceptanceGroupLabel,meetingTentativeAcceptanceGroupLabel,automaticReplyGroupLabel,undeliveredReportGroupLabel,otherGroupLabel};